/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const MinusIcon = ({ className }) => {
  return (
    <svg
      className={className}
      style={{transform: 'rotate(270deg)'}}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="3.75"
        y="10.75"
        width="16.5"
        height="2.5"
        rx="1.25"
        fill="#F6FAFD"
        stroke="#F6FAFD"
        strokeWidth="0.5"
      />
    </svg>
  )
}
